import { useEffect, useState } from 'react';
import Logo from '@/components/feature/Logo';
import { contactInfo } from '@/mocks/home';

const ACCOUNT_URL = 'https://letmeclean.bookingkoala.com/login';

const links = [
  { href: '#services', label: 'Services' },
  { href: '#how-it-works', label: 'How it works' },
  { href: '#faq', label: 'FAQ' },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <div className="grad-brand text-foreground-950 text-center text-xs md:text-sm font-bold px-4 py-2">
        <strong className="font-bold">−10% on your first booking</strong> — applied automatically at checkout
      </div>
      <header className={`sticky top-0 z-40 bg-background-50 transition-shadow ${scrolled ? 'shadow-pink border-b border-background-200' : 'border-b border-transparent'}`}>
        <div className="max-w-6xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
          <Logo />
          <nav className="hidden md:flex items-center gap-6 lg:gap-8">
            {links.map((l) => (
              <a key={l.href} href={l.href} className="text-sm font-medium text-foreground-800 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors">{l.label}</a>
            ))}
            <a href={contactInfo.phoneHref} className="hidden lg:flex items-center gap-1.5 text-sm font-semibold text-foreground-950 whitespace-nowrap cursor-pointer">
              <span className="w-4 h-4 flex items-center justify-center text-primary-600"><i className="ri-phone-line"></i></span>
              {contactInfo.phone}
            </a>
            <a href={ACCOUNT_URL} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-sm font-medium text-foreground-800 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors">
              <span className="w-4 h-4 flex items-center justify-center text-primary-600"><i className="ri-user-line"></i></span>
              My Account
            </a>
            <a href="#book" className="grad-cta text-background-50 text-sm font-semibold px-6 py-2.5 rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 shadow-pink hover:-translate-y-0.5 hover:shadow-pink-lg">Book now</a>
          </nav>
          <div className="flex md:hidden items-center gap-2">
            <a href="#book" className="grad-cta text-background-50 text-sm font-semibold px-4 py-2 rounded-full whitespace-nowrap cursor-pointer shadow-pink">Book now</a>
            <button type="button" onClick={() => setOpen(!open)} aria-label="Menu" className="w-10 h-10 flex items-center justify-center text-2xl text-foreground-950 cursor-pointer whitespace-nowrap">
              <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
            </button>
          </div>
        </div>
        {open && (
          <nav className="md:hidden bg-background-50 border-t border-background-200 px-4 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2.5 text-base font-medium text-foreground-900 cursor-pointer">{l.label}</a>
            ))}
            <a href={contactInfo.phoneHref} className="py-2.5 text-base font-semibold text-primary-600 cursor-pointer">{contactInfo.phone}</a>
            <a href={ACCOUNT_URL} target="_blank" rel="noopener noreferrer" onClick={() => setOpen(false)} className="py-2.5 text-base font-medium text-foreground-900 cursor-pointer">My Account</a>
          </nav>
        )}
      </header>
    </>
  );
}